import { EAccountStatus } from "../enum/EAccountStatus";


export default class UserDetails { 
    
    AccountStatus?: EAccountStatus;

    FirstName?:string;

    LastName?:string;

    BusinessName?:string;

    Email?:string;

    Website?:string;

    AdminSourceId?:number;

    NameInitials?:string;

    CanShowV5:boolean | undefined;
}